import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"10px"} }
const _hoisted_2 = { class: "mt20" }

import { ref, reactive, unref, onMounted, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import UserInfo from './components/UserInfo.vue';
import ContractPedingCard from './components/ContractPeding.vue';
import PerformPedingCard from './components/PerformPeding.vue';
import PerformAmountCard from './components/PerformAmount.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(UserInfo)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, {
        gutter: 10,
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xl: 16,
            lg: 16,
            md: 24,
            sm: 24,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(ContractPedingCard)
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(PerformPedingCard)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xl: 8,
            lg: 8,
            md: 24,
            sm: 24,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mb0"
              }, {
                default: _withCtx(() => [
                  _createVNode(PerformAmountCard)
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "mt20"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})